<template>
  <ScrollableCard
    class="RunTimeline"
  >
    <Transition>
      <RunTimelineMonthList
        v-if="months.length > 0"
        class="RunTimeline__monthList"
        v-bind="{months, isInPast}"
      />
    </Transition>
  </ScrollableCard>
</template>

<script lang="ts" setup>
import groupRunsByMonth from "@/lib/utils/date/groupRunsByMonth";
import { RunForTimeline } from "@/stores/useRunCarouselStore.ts";
import { computed } from "vue";
import RunTimelineMonthList from "./RunTimelineMonthList.vue";
import ScrollableCard from "./ScrollableCard.vue";

const {
  runs,
  sort = "asc",
  isInPast = false,
} = defineProps<{
  runs: Array<RunForTimeline>,
  sort?: "asc" | "desc",
  isInPast?: boolean,
}>();

const months = computed(() => groupRunsByMonth(runs, sort));
</script>

<style lang="scss" scoped>
.RunTimeline {
  position: relative;
  height: 100%;
}

.RunTimeline__monthList {
  transition: 350ms opacity;

  &.v-enter-from,
  &.v-leave-to {
    opacity: 0;
  }
}
</style>
